import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const selectItem = createAction('selectItem');
export const setSearchDate = createAction('setSearchDate');
export const setTruckTypes = createAction('setTruckTypes');
export const setActiveList = createAction('setActiveList');
export const setListLoading = createAction('setListLoading');
export const setSearchRadius = createAction('setSearchRadius');
export const setInitialState = createAction('setInitialState');
export const changeActiveList = createAction('changeActiveList');
export const setLocationValue = createAction('setLocationValue');
export const setDriverComments = createAction('setDriverComments');
export const setDriverInitials = createAction('setDriverInitials');
export const setSearchLocation = createAction('setSearchLocation');
export const setTableTitleSort = createAction('setTableTitleSort');
export const getItemListRequest = createAction('getItemListRequest');
export const getItemListSuccess = createAction('getItemListSuccess');
export const setTableTitleFilter = createAction('setTableTitleFilter');
export const getDriverDataRequest = createAction('getDriverDataRequest');
export const toggleTeamFilterValue = createAction('toggleTeamFilterValue');
export const toggleUnassignedLoads = createAction('toggleUnassignedLoads');
export const resetListAndPagination = createAction('resetListAndPagination');
export const deleteDriverNoteRequest = createAction('deleteDriverNoteRequest');
export const deleteReservationRequest = createAction('deleteReservationRequest');
export const getSearchLocationRequest = createAction('getSearchLocationRequest');
export const getUnassignedLoadsRequest = createAction('getUnassignedLoadsRequest');
export const getUnassignedLoadsSuccess = createAction('getUnassignedLoadsSuccess');
export const setDriverAvailableRequest = createAction('setDriverAvailableRequest');
export const setDriverUnavailableRequest = createAction('setDriverUnavailableRequest');
export const updateTelCustomStatusSuccess = createAction('updateTelCustomStatusSuccess');
export const getAvailableDriverByGuidRequest = createAction('getAvailableDriverByGuidRequest');
export const getAvailableDriverByGuidSuccess = createAction('getAvailableDriverByGuidSuccess');
export const createOrUpdateDriverNoteRequest = createAction('createOrUpdateDriverNoteRequest');
export const createOrUpdateReservationRequest = createAction('createOrUpdateReservationRequest');
export const patchUpdateAvailableDriverRequest = createAction('patchUpdateAvailableDriverRequest');
export const updateAvailableDriversColorRequest = createAction('updateAvailableDriversColorRequest');
export const assignDriverOnAvailableDriverRequest = createAction('assignDriverOnAvailableDriverRequest');
export const assignDriverOnAvailableDriverSuccess = createAction('assignDriverOnAvailableDriverSuccess');
// all drivers
export const setAllDriversListLoading = createAction('setAllDriversListLoading');
export const getAllDriversListRequest = createAction('getAllDriversListRequest');
export const getAllDriversListSuccess = createAction('getAllDriversListSuccess');
export const resetAllDriversListAndPagination = createAction('resetAllDriversListAndPagination');
